<script setup lang="ts">
import { Ref, ref } from "vue";
import SpecialCaseModals from "@/components/DailyReportUpdateModalParts/SpecialCaseModals.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { DELIVERY_PLAN_RULE_2024_START_DATE_TIME } from "@/services/consts";

const props = defineProps<{
  deliveryPlan: DeliveryPlan
  createAuthority: boolean
  showFlash: (message: string, show: boolean, type: string, fadeout: boolean) => void
}>()

const modalStatus: Ref<boolean> = ref(false)

function changeModalStatus(bool: boolean) {
  modalStatus.value = bool;
}

function showButton() {
  return props.deliveryPlan.leaving_warehouse_date_time >= DELIVERY_PLAN_RULE_2024_START_DATE_TIME
}
</script>
<template>
  <v-btn
    v-if="showButton()"
    color="grey-lighten-4"
    style="color: red !important;"
    @click="changeModalStatus(true)"
  >
    {{ $t('pages.dailyReports.updateModal.applicationOfSpecialCaseButton') }}
  </v-btn>
  <SpecialCaseModals
    v-model="modalStatus"
    :deliveryPlan="props.deliveryPlan"
    :createAuthority="props.createAuthority"
    :showFlash="props.showFlash"
    @cancel="changeModalStatus"
  />
</template>
